import { atom } from 'jotai';

export const formAtom = atom({
    name: '',
    email: '',
    phoneNumber: '',
    yearlyDocumentVolume: '',
    description: ''
});
